import { useCallback } from "react";
import { fetchQuery, useQueryLoader, useRelayEnvironment } from "react-relay";
import { WIDGET_SIGNAL_OVERVIEW_PREVIEW_QUERY } from "./WidgetSignalOverviewPreview";
import { useDebouncedCallback } from "use-debounce";
import { useFocusEffect } from "@react-navigation/native";
import { WidgetSignalOverviewPreviewQuery } from "./__generated__/WidgetSignalOverviewPreviewQuery.graphql";

export function useWidgetSignalOverviewPreviewQuery({
  storecastId,
  teamIds,
  setTeamIds: _setTeamIds,
}: {
  storecastId: string;
  teamIds: string[];
  setTeamIds(_: string[]): void;
}) {
  const [query, loadQuery] =
    useQueryLoader<WidgetSignalOverviewPreviewQuery>(
      WIDGET_SIGNAL_OVERVIEW_PREVIEW_QUERY
    );

  const environment = useRelayEnvironment();

  const loadPreviewQuery = useDebouncedCallback(
    async (newTeamIds: string[]) => {
      try {
        const variables = {
          storecastId,
          input: {
            teamIds: newTeamIds.length === 0 ? null : newTeamIds,
            size: "TWO_X_TWO" as const,
          },
        };
        await fetchQuery(
          environment,
          WIDGET_SIGNAL_OVERVIEW_PREVIEW_QUERY,
          variables
        ).toPromise();
        loadQuery(variables, {
          fetchPolicy: "store-and-network",
        });
      } catch {}
    },
    300
  );
  useFocusEffect(
    useCallback(() => {
      loadPreviewQuery(teamIds);
    }, [teamIds, loadPreviewQuery])
  );
  const setTeamIds = useCallback(
    (teamIds: string[]) => {
      _setTeamIds(teamIds);
      loadPreviewQuery(teamIds);
    },
    [_setTeamIds, loadPreviewQuery]
  );
  return [query, setTeamIds] as const;
}
